<template>
  <div class="fill-blank-container">
    <answer-render ref="answer" :config="config">
      <div slot="body">
        <FormItem
          prop="value"
          :rules="rules"
        >
          <div ref="fillAnswer" class="fill-blank-answer"></div>
        </FormItem>
      </div>
    </answer-render>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import answerValidate from './answerValidate'
const REG_POSITION_TAGS = ['插入短位置', '插入长位置']
export default {
  name: 'FillBlankBoxAnswer',
  props: ['config'],
  data () {
    const {config: { answerConfig: { requireInd } }, cvtLang, getSurveyInfoLang } = this
    return {
      inited: false,
      rules: [
        {
          validator: (rule, value, callback) => {
            let errors = []
            if (answerValidate) {
              errors = answerValidate.validate.bind(this.config)(this).errors
            } else {
              if (requireInd === '1') {
                errors.push(cvtLang('tipAnswerNull', getSurveyInfoLang().tipAnswerNull))
              }
            }
            if (errors.length) {
              let currEl = document.querySelector('.ivu-form-item-error-tip')
              // 显示提示
              if (currEl) {
                currEl.style.display = 'block'
              }
              return callback(errors)
            }
            callback()
          }
        }
      ]
    }
  },
  components: {},
  watch: {},
  computed: {
    ...mapState({
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
      lang: ({Question}) => Question.lang,
      langMap: ({Question}) => Question.langMap
    })
  },
  methods: {
    renderAnswer () {
      let templete = this.config.quNote
      const _this = this
      if (!templete) {
        return
      }
      let answerList = this.config.descList
      let tags = REG_POSITION_TAGS.join('|')
      let tagIndex = 0

      templete = templete.replace(new RegExp(tags, 'g'), text => {
        const maxLength = text === '插入短位置' ? 8 : 16
        if (this.config.descList.length < this.config.quNote.match(new RegExp(tags, 'g')).length) {
          answerList.push({
            value: this.config.descList[tagIndex] ? this.config.descList[tagIndex].value : ''
          })
        }
        return `<Input v-model="answerList[${tagIndex++}].value" class="fill-blank-input" :class="[${maxLength} === 8 ? 'input8' : 'input16']" :maxlength="${maxLength * 2}" @on-change="inputChange"/>`
      })
      var MyComponent = Vue.extend({
        template: `<div class="qu-fill-answer"><span>${templete}</span></div>`
      })
      new MyComponent({
        data: {
          answerList
        },
        methods: {
          inputChange(el) {
            let currEl = el.path && el.path[4] || null
            let errors = []
            errors = answerValidate.validate.bind(_this.config)(_this).errors
            if (currEl) {
              if (!errors.length) {
                // 清除提示
                if (currEl.nextElementSibling && currEl.nextElementSibling.className === 'ivu-form-item-error-tip') {
                  currEl.nextElementSibling.style.display = 'none'
                }
              } else {
                // 显示提示
                if (currEl.nextElementSibling && currEl.nextElementSibling.className === 'ivu-form-item-error-tip') {
                  currEl.nextElementSibling.style.display = 'block'
                }
              }
            }
          }
        },
        mounted() {
          setTimeout(() => {
            let currEl = this.$el.parentNode.lastChild
            // 清除默认提示
            if (currEl && currEl.className && currEl.className.indexOf('ivu-form-item-error-tip') > -1) {
              currEl.style.display = 'none'
            }
          })
        }
      }).$mount(this.$refs.fillAnswer)
    },
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    },
    getSurveyInfoLang: function () {
      return this.surveyInfoLang
    }
  },
  created () {},
  mounted () {
    this.$nextTick(() => {
      this.renderAnswer()
    })
  }
}
</script>
<style lang="scss">
  .fill-blank-container {
    .qu-fill-answer {
      margin-top: 20px;
      // font-size: 28px;
      font-family: PingFang-SC-Medium;
      // font-weight: 500;
      color: rgba(51, 52, 46, 1);
      line-height: 68px;
      border: none;
      // background: #F8F8F8;

      .ivu-icon-ios-loading:before {
        display: none;
      }
    }

    .fill-blank-input {
      margin: 0 8px;
      .ivu-input {
        text-align: center;
        // height: 42px;
        padding: 0px 6px;
        // font-size: 28px;
        font-family: PingFang-SC-Medium;
        color: #000000;
        font-weight: 500;
        // background: #F8F8F8;
        border: none;
        border-bottom: 2px solid #8A8A8A;
        border-radius: 0;
        box-shadow: none;
        position: relative;
        top: -4px;
      }
    }

    .input8 {
      width: 160px
    }

    .input16 {
      width: 300px;
    }
  }
  .answer-pc {
    .qu-fill-answer {
      line-height: 36px;
      margin-top: 0px;
    }
    .fill-blank-container {
      .fill-blank-input {
        margin: 0 8px;
        .ivu-input {
          border-bottom: 1px solid #8A8A8A;
          padding: 0px 4px;
          text-align: center;
          position: relative;
          top: -2px;
        }
      }
      .input8 {
        width: 110px
      }

      .input16 {
        width: 220px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/FillBlankBox/FillBlankBoxAnswer.vue